/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React from 'react';
import classNames from 'classnames';
// @material-ui/core components
import LinearProgress from '@material-ui/core/LinearProgress';
import withStyles from '@material-ui/core/styles/withStyles';
import StepCompleted from 'src/assets/images/StepCompleted.svg';
import StepStarted from 'src/assets/images/StepStarted.svg';
import ReportUsageProgressStepCurrent from 'src/assets/images/ReportUsageProgressStepCurrent.svg';
import ReportUsageProgressStepCompleted from 'src/assets/images/ReportUsageProgressStepCompleted.svg';
import { useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import { SMALL_TEXT_PX, FONT_FAMILY_DEMI, DARK_GRAY_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';
 
const customStepperStyle = {
    stepper: {
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-around',
        padding: '12px 0px 0px 0px',
        width: '100%',
        margin: '10px 0 10px 0',
    },
 
    stepper__step: {
        position: 'relative',
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
    },
 
    stepper__step__index: {
        width: '19px',
        height: '19px',
        lineHeight: '3px',
        borderRadius: '50%',
        background: '#989898 0% 0% no-repeat padding-box',
        border: '1px solid #FFFFFF',
        textAlign: 'center',
        marginBottom: '5px',
    },
 
    stepper__step__index_not_completed: {
        width: '10px',
        height: '10px',
    },
 
    stepper__step_index_completed: {
        backgroundImage: `url(${StepCompleted})`,
    },
    stepper__step__label: {
        letterSpacing: '0px',
        color: DARK_GRAY_FONT_COLOR,
        opacity: 1,
        margin: 0,
        fontFamily: FONT_FAMILY_DEMI,
        fontSize: SMALL_TEXT_PX,
        lineHeight: '24px',
        position: 'absolute',
        bottom: '-20px',
        whiteSpace: 'nowrap',
    },
 
    labelContainer: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
    },
 
    // gap between line and dots
    linearProgress: {
        flex: '1 1 auto',
        position: 'absolute',
        top: 9,
        left: 'calc(-50% + 5px)',
        right: 'calc(50% + 5px)',
        backgroundColor: '#989898 0% 0% no-repeat padding-box',
    },
 
    linearProgressInitial: {
        flex: '1 1 auto',
        position: 'absolute',
        top: 7,
        left: 'calc(-50% + 5px)',
        right: 'calc(50% + 5px)',
        backgroundColor: '#989898 0% 0% no-repeat padding-box',
    },
 
    bar: {
        backgroundColor: '#1DB2B2',
    },
 
    currentStep: {
        backgroundColor: 'white',
        color: '#fff',
        fontWeight: '500',
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        backgroundImage: `url(${StepStarted})`,
        // boxShadow:
        //     'inset 0 3.5px 0 #1DB2B2, inset -3.3px 0 0 #1DB2B2,   inset 0 -3.3px 0 #1DB2B2, inset 3.3px 0 0 #1DB2B2',
    },
 
    done: {
        // backgroundColor: '#1DB2B2 !important',
        color: '#fff',
        fontWeight: '500',
    },
 
    // Styles for the first child
    stepper__step_first: {
            alignItems:'flex-start', 
    },
 
    // Styles for the last child
    stepper__step_last: {
            alignItems:'end', 
    },
};
 
function CustomStepper({
    steps,
    classes,
    handleClick = () => {},
    isFromReportUsage = false
}) {
    function StepContent({ done, index }) {
        return done ? '' : '';
    }
    const isErrorExists = useSelector(
        (state) => state.reportUsageRootReducer.isErrorExists
    );
    const myCaseResourceType = useSelector(
        (state) => state.reportUsageRootReducer.myCaseResourceType
    );

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const ProgressBar = ({ current, step, progress }) => {
        const stepLables = Object.keys(steps);  
        const barClass = isFromReportUsage ? 'custom-progress-bar report-usage' : 'custom-progress-bar';
        return (
            <LinearProgress
                variant="determinate"
                value={progress}
                classes={{
                    root:
                        steps[stepLables[0]]?.current &&
                        !steps[stepLables[1]]?.done &&
                        !steps[stepLables[2]]?.done
                            ? classes.linearProgressInitial
                            : classes.linearProgress,
                    bar: barClass,
                }}
            />
        );
    };
// Add custom style for the progress bar
const style = document.createElement('style');
style.innerHTML = `
    .custom-progress-bar {
        background-color: #1DB2B2 !important;
    }
    .custom-progress-bar.report-usage {
        background-color: #C529BB !important;
    }
`;
if (!document.head.querySelector('style[data-custom-progress-bar]')) {
    style.setAttribute('data-custom-progress-bar', 'true');
    document.head.appendChild(style);
}
 
    function renderStep(step, key) {
        const { current, progress, label, done, displayLabel } = steps[step];
        const isFirstChild = key === 0;
        const isLastChild = key === steps.length - 1;
        const stepClasses = classNames({
            [classes.stepper__step__index]: true,
            [classes.currentStep]: current,
            [classes.done]: done,
            [classes.stepper__step__index_not_completed]:
                myCaseResourceType === 'reportUsage'
                    ? (!current && !done) || isErrorExists
                    : !current && !done,
            [classes.stepper__step_index_completed]:
                myCaseResourceType === 'reportUsage'
                    ? done && !isErrorExists
                    : done
        });
        const stepsLength = Object.keys(steps).length;

        return (
            <li
                className={classes.stepper__step}
                key={key}
                id={label}
                onClick={() => {
                    if (myCaseResourceType === 'reportUsage') {
                        !isErrorExists && handleClick(label);
                    } else {
                        handleClick(label);
                    }
                }}
            >
                <div
                    className={classNames(
                        classes.labelContainer,
                        window.innerWidth < sizes.mobileDevice   ?  {
                            [classes.stepper__step_first]: key === 0,  
                            [classes.stepper__step_last]: key === stepsLength - 1,  
                        }
                        : <></>
                    )}
                >
                    <span
                        className={stepClasses}
                        style={
                            current
                                ? { backgroundImage: `url(${isFromReportUsage ? ReportUsageProgressStepCurrent : StepStarted})` }
                                : stepClasses.includes(classes.stepper__step_index_completed)
                                    ? { backgroundImage: `url(${isFromReportUsage ? ReportUsageProgressStepCompleted : StepCompleted})` }
                                    : undefined
                        }
                    >
                        <StepContent done={done} index={key} />
                    </span>
                    <p className={classes.stepper__step__label}>
                        {displayLabel}
                    </p>
                </div>
                {!!key && (
                    <ProgressBar
                        current={current}
                        step={key}
                        progress={progress}
                    />
                )}
            </li>
        );
    }
 
    return (
        <ul className={classes.stepper}>
            {Object.keys(steps).map(renderStep)}
        </ul>
    );
}
 
export default withStyles(customStepperStyle)(CustomStepper);